import React from "react";
import { MONTHS, fa } from "../core/format";

export default function MonthNav({ ym, onChange }) {
  const move = (d) => {
    let m = ym.m + d, y = ym.y;
    if (m > 12) { m = 1; y++; } if (m < 1) { m = 12; y--; }
    onChange({ y, m });
  };
  return (
    <div style={{ display: "flex", gap: 6, alignItems: "center", minWidth: 210 }}>
      <button className="icon-btn" onClick={() => move(1)} aria-label="ماه بعد"><i className="fa-solid fa-chevron-right" /></button>
      <div style={{ flex: 1, textAlign: "center", fontWeight: 800, color: "var(--primary)" }}>{MONTHS[ym.m - 1]} {fa(ym.y)}</div>
      <button className="icon-btn" onClick={() => move(-1)} aria-label="ماه قبل"><i className="fa-solid fa-chevron-left" /></button>
    </div>
  );
}
